import { Skeleton } from 'antd';
import clsx from 'clsx';
interface FormSkeletonProps {
    className?: string;
}
export function FormSkeleton({ className }: FormSkeletonProps) {
    return (
        <div
            className={clsx(
                'w-full max-w-3xl p-6 sm:p-10 bg-white rounded-xl shadow-sm box-shadow-sm animate-pulse grid gap-6',
                className
            )}
        >
            {/* Title placeholder */}
            <Skeleton.Input active size="default" className="w-28 rounded-lg" />

            {/* Two columns rows */}
            <div className="grid gap-4 sm:grid-cols-2">
                <Skeleton.Input
                    active
                    size="large"
                    className="w-full rounded-lg"
                />
                <Skeleton.Input
                    active
                    size="large"
                    className="w-full rounded-lg"
                />
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
                <Skeleton.Input
                    active
                    size="large"
                    className="w-full rounded-lg"
                />
                <Skeleton.Input
                    active
                    size="large"
                    className="w-full rounded-lg"
                />
            </div>

            {/* Large text area */}
            <Skeleton.Input
                active
                size="large"
                className="w-full h-28 rounded-lg"
            />

            <div className="grid gap-4 sm:grid-cols-2">
                <Skeleton.Input
                    active
                    size="large"
                    className="w-full rounded-lg"
                />
                <Skeleton.Input
                    active
                    size="large"
                    className="w-full rounded-lg"
                />
            </div>

            {/* Button placeholder aligned right */}
            <div className="flex justify-end">
                <Skeleton.Button
                    active
                    size="small"
                    className="w-20 rounded-lg"
                />
            </div>
        </div>
    );
}
